import React from 'react';
// Core Components
import ModalUI from "../ModalsUI/index";
import HeaderBillboards from '../HeadersUI/HeaderBillboards';
import BillboardFooter from '../BillboardUI/BillboardFooter';
import BillboardSideBar from "../BillboardUI/BillboardSideBar";
import TempLoadingScreen from '../LoadingController/TempLoadingScreen';

export default function BillboardDisplay() {
    return (
        <React.Fragment>
            <HeaderBillboards />
            <BillboardSideBar />
            <BillboardFooter />
            <ModalUI />
            <TempLoadingScreen />
        </React.Fragment>
    )
}